<template>
  <div class="member-row qrw-box-shadow-1dp" v-if="waiter">
    <div class="avatar-circle qrw-label-md">
      {{ firstNameLetter }}
    </div>
    <div class="qrw-heading-xs bold qrw-text-content-base-primary w-100">
      {{ waiter.name }}
    </div>
    <!-- <div class="qrw-heading-xs qrw-text-content-base-secondary w-100">Manager</div> -->
    <!-- <div class="qrw-heading-xs qrw-text-secondary w-100">Department</div> -->
    <BaseIconButton
      @click="$emit('delete')"
      icon="x"
      size="md"
      variant="ghost"
      textColor="content-error-primary"
      class="del-btn"
    />
  </div>
</template>

<script>
export default {
  props: {
    waiterId: String,
  },
  computed: {
    waiter() {
      return this.$store.state.waiters.find((w) => w._id === this.waiterId);
    },
    firstNameLetter() {
      return this.waiter.name.substring(0, 1);
    },
  },
};
</script>

<style scoped>
.member-row {
  display: flex;
  flex-direction: row;
  padding: 8px 16px;
  column-gap: 24px;
  border-radius: 8px;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
}

.member-row:hover {
  box-shadow: 0px 2px 4px 2px rgba(0, 0, 0, 0.16);
}

.del-btn {
  visibility: hidden;
}

.member-row:hover .del-btn {
  visibility: visible;
}

.avatar-circle {
  border-radius: 50%;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: center;
  background: var(--qrw-background-base-inverse-primary);
  color: var(--qrw-content-base-inverse-primary);
  width: 40px;
  height: 40px;
  min-width: 40px;
  max-height: 40px;
}
</style>
